import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { DeviceDetectorService } from "ngx-device-detector";

import { RoleAccessService } from "@bitwarden/web-vault/app/services/permission/role-access.service";
import { GlossRoutes } from "@bitwarden/web-vault/app/models/enum/routes.enum";

/**
 * Desktop + BETA_ACCESS only. Redirects to home (views) when blocked (e.g. mobile deep link).
 */
@Injectable({
  providedIn: "root",
})
export class SourceExplorerGuard implements CanActivate {
  constructor(
    private router: Router,
    private deviceService: DeviceDetectorService,
    private roleAccess: RoleAccessService,
  ) {}

  canActivate(): boolean | UrlTree {
    if (!this.deviceService.isDesktop()) {
      return this.router.createUrlTree(["/", GlossRoutes.Views]);
    }
    if (!this.roleAccess.isBetaUser()) {
      return this.router.createUrlTree(["/", GlossRoutes.Views]);
    }
    return true;
  }
}
